/* @flow weak */
import Link from 'components/Link';
import Glyph from 'components/Glyph';
import PropTypes from 'prop-types';
import * as React from 'react';
import Text from 'components/Text';

import cx from 'classnames';

import './styles/AppLayoutContentViewHeader.scss';

export default class AppLayoutContentViewHeader extends React.Component<$FlowFixMeProps> {
  static propTypes = {
    title: PropTypes.node.isRequired,
    renderPreviousButton: PropTypes.bool,
    onRequestPrevious: PropTypes.func,
  };

  renderTitleWithPreviousButton(title) {
    return (
      <Link
        color="pitch"
        className="AppLayoutContentViewHeader-previousButton"
        onClick={this.props.onRequestPrevious}>
        <Glyph name="arrow-left" color="brand" size="large" />
        {title}
      </Link>
    );
  }

  render() {
    const { title, children, className } = this.props;
    return (
      <div className={cx('AppLayoutContentViewHeader', className)}>
        <Text className="AppLayoutContentViewHeader-title" size="medium" truncate>
          {this.props.renderPreviousButton ? this.renderTitleWithPreviousButton(title) : title}
        </Text>
        {children && <div className="AppLayoutContentViewHeader-content">{children}</div>}
      </div>
    );
  }
}
